import { h, Fragment } from 'preact';
import { createPortal } from 'preact/compat';

import SkyItBox from '../../../components/3-molecules/sky-it-box/sky-it-box';
import SelectBox from '../../../components/3-molecules/select-box/select-box';
import ModalPrivacy from '../../../components/3-molecules/modal-privacy/modal-privacy';
import { parseParselyPrefsForSelectBox } from '../../../utils/parsers';
import { getLabel } from '../../../../labels/labelling-service';

export const renderInPage = ({
  state,
  htmlProps,
  handlers,
  isActiveInPage,
  blockType,
  showMoreText,
  showLessText,
  ctaPrimaryLabelInPage,
  confirmInPageMessage,
  parselyCommonState,
  widget,
  modalPrivacyContainer,
  showModalPrivacy,
}) => {
  if (state.isLoading && !state.isMutationPending && !state.isSubscriptionPending) {
    return null;
  }

  const selectBoxesModifiers = ['2-cols', '3-cols-tablet', '5-cols-desktop', 'no-border', 'with-square-options'];
  const options = parseParselyPrefsForSelectBox({
    preferences: state.widgetPreferences,
    selectedPreferences: state.selectedOptions,
    maxOptions: htmlProps.maxOptions,
  });

  return (
    <Fragment>
      <div
        id={`${widget.htmlId}InPage`}
        className="c-user-preferences__parsely c-user-preferences__widget"
        data-state={isActiveInPage ? 'active' : ''}
      >
        <SkyItBox
          title={htmlProps.title}
          description={htmlProps.description}
          onInfoClick={handlers.handleInfoClick}
          options={
            parselyCommonState.currentConsent
              ? [
                  {
                    text: getLabel('parsely.common.privacy.cancel.consent'),
                    onClick: () => handlers.handlePrivacyMutation(false),
                  },
                ]
              : []
          }
        >
          <SelectBox
            showMore={showMoreText}
            showLess={showLessText}
            modifiers={selectBoxesModifiers}
            options={options}
            maxOptions={htmlProps.maxOptions}
            selectedOptions={state.selectedOptions}
            onOptionClick={(option) => {
              handlers.handleOptionInPageClick({
                blockType,
                option,
                ctaPrimaryLabelInPage,
                confirmInPageMessage,
                consent: parselyCommonState.currentConsent,
              });
            }}
          />
        </SkyItBox>
      </div>
      {showModalPrivacy &&
        createPortal(
          <ModalPrivacy
            isActive
            isLoading={state.isMutationPrivacyPending}
            htmlId={widget.htmlId}
            htmlProps={htmlProps}
            onCancel={handlers.handleModalPrivacyCancelInPage}
            onConfirm={() =>
              handlers.handlePrivacyMutationInPage({
                consentOptionSelected: true,
                blockType,
                confirmInPageMessage,
                ctaPrimaryLabelInPage,
              })
            }
          />,
          modalPrivacyContainer
        )}
    </Fragment>
  );
};
